import { Col, Button } from "react-bootstrap";
import { withStatisticWapper } from "../statistics";
import { useState } from "react";
import { getListIdByStatusValue } from "../../../services/serviceHelper";
import FontFa from "../../../components/fontFa/fontFa";
import LinkDocumentModal from "../../document/modal/link-document-modal";
import { useSearchParams } from "../../../hook/use-search-params";
import { usePublicDocumentContent } from "../../document/hooks/published-documents/use-public-document-content";
import { Spin } from "antd";
import { ContentDiffViewer } from "../../../components/diff-viewer";

export const VersionDocumentContent = withStatisticWapper(() => {
  const [openLinkDocumentModal, setOpenLinkDocumentModalModal] = useState(false);
  const [listId, setListId] = useState<any>(getListIdByStatusValue("", openLinkDocumentModal));
  const { searchParams, replaceSearchParams } = useSearchParams();
  const docId = searchParams.get("docId");
  const { differenData, isLoading } = usePublicDocumentContent();

  const onPicked = (e: any) => {
    searchParams.set("docId", e.docWorkingId + "");
    replaceSearchParams(searchParams);
  };

  const toggleLinkDocumentModal = () => {
    setOpenLinkDocumentModalModal(!openLinkDocumentModal);
    setListId(getListIdByStatusValue("", !openLinkDocumentModal));
  };

  return (
    <>
      <Col sm={12} md={12} className="py-3">
        <Col className="py-3 statistic-header">
          <h3>Thống kê nội dung sửa đổi</h3>
          <p>
            <i>Thống kê các phiên bản của nội dung sửa đổi cho từng tài liệu</i>
          </p>
          <div className="pt-1 d-flex">
            <h6 className="pt-2">Chọn một tài liệu để thống kê</h6>
            <div className="px-4 d-flex align-items-center">
              <Button className="btn mr-2" variant="outline-info" onClick={toggleLinkDocumentModal}>
                <FontFa name="faFilter" size={"xs"} />
              </Button>
            </div>
          </div>
        </Col>
      </Col>
      {docId && (
        <Col sm={10} md={10} className="py-3">
          {isLoading ? (
            <Spin />
          ) : (
            differenData?.map((e: any, index) => (
              <ContentDiffViewer
                oldContent={`${e[0]?.Content}`}
                newContent={`${e[1]?.Content}`}
                id={e[1]?.Id}
                key={index}
                index={index}
              />
            ))
          )}
        </Col>
      )}
      <LinkDocumentModal
        onClose={toggleLinkDocumentModal}
        isOpen={openLinkDocumentModal}
        isUrl={false}
        onPicked={onPicked}
        listId={listId}
      />
    </>
  );
});
